module.exports = __webpack_public_path__ + "img/214-malawi.e6701841.svg";